import React, { useState, useEffect } from "react";
import "./Navbar.scss";

import logo from "../../img/Logo-line_color.png";
import logo2 from "../../img/hp-logo_drop.png";
import pin from "../../img/icons/icon_Loc-blue.png";
import pin2 from "../../img/icons/icon_Loc-white.png";
import getVariantClasses from "../../helpers/getVariantClasses";
import useBreakpoint from "../../hooks/useBreakpoint";
import useScrollPos from "../../hooks/useScrollPos";
import MobileNav from "../MobileNav/MobileNav";
import useWindowLocation from "../../hooks/useWindowLocation";
import PageLink from "../share/PageLink/PageLink";

interface INavbarProps {
  variant: string;
  offset: number;
}

const Navbar: React.FC<INavbarProps> = ({ variant, offset }) => {
  const [showDrop, setShowDrop] = useState(false);
  const [showDefaultNav, setShowDefaultNav] = useState(false);
  const location = useWindowLocation().pathname;

  const BreakpointXL = useBreakpoint("xl");
  const className = getVariantClasses("Navbar", variant);
  const currentScrollY = useScrollPos();

  const ignorePages = ["/portfolio", "/meta/impressum", "/products", "/404", "/contact"];

  if (location == "/faq") {
    offset = 450;
  }

  useEffect(() => {
    const diff = offset ? offset : window.innerHeight / 2;
    if (
      currentScrollY >= diff ||
      ignorePages.find((element) => location.includes(element))
    ) {
      setShowDefaultNav(true);
    } else {
      setShowDefaultNav(false);
    }
  }, [currentScrollY, location]);

  const getLink = (to, label) => {
    return (
      <PageLink
        className={`Navbar__link${
          location && location.includes(to) ? " Navbar__link--active" : ""
        }`}
        to={to}
      >
        {label}
      </PageLink>
    );
  };

  const productsActive =
    showDrop || (location && location.includes("/product"));

  return (
    <nav
      className={
        variant
          ? className
          : "Navbar" + `${showDefaultNav ? "" : " Navbar--transparent"}`
      }
      role="navigation"
      aria-label="main-navigation"
    >
      <div className="Navbar__container">
        <div id="navMenu" className={`Navbar__desktop`}>
          <div className="Navbar__left">
            <PageLink to="/" className="Navbar__start" title="Logo">
              {variant === "transparent" || !showDefaultNav ? (
                <img src={logo2} alt="Heinze-Pool" />
              ) : (
                <img src={logo} alt="Heinze-Pool" />
              )}
            </PageLink>
          </div>

          {BreakpointXL ? (
            <MobileNav variant={!showDefaultNav && "white"} />
          ) : (
            <div className="Navbar__right">
              {getLink("/service", "Leistungen")}
              <div className="Navbar__ext">
                {/* Bewusst ein Button und kein Link: als TransitionLink
                    startete das Plugin die Navigation nach /products, bevor
                    das preventDefault im onClick ueberhaupt dran war - das
                    Dropdown ging deshalb nie auf. */}
                <button
                  type="button"
                  className={`Navbar__link Navbar__toggle${
                    productsActive ? " Navbar__link--active" : ""
                  }`}
                  aria-haspopup="true"
                  aria-expanded={showDrop}
                  onClick={() => setShowDrop(!showDrop)}
                >
                  Produkte
                </button>
                <div
                  className={`Navbar__dropdown${
                    showDrop ? " Navbar__dropdown--active" : ""
                  }`}
                >
                  {getLink("/products", "Übersicht")}
                  {getLink("/product/pools", "Pools")}
                  {getLink("/product/überdachung", "Abdeckung")}
                  {getLink("/product/wasserpflege", "Wasserpflege")}
                  {getLink("/product/zubehör", "Zubehör")}
                </div>
              </div>
              {getLink("/portfolio", "Projekte")}
              {getLink("/about", "Über uns")}
              {getLink("/poolbau", "Poolbau")}
              <PageLink
                className={`Navbar__link${location && location.includes("/contact") ? " Navbar__link--active" : ""}`}
                to="/contact"
              >
                {variant === "transparent" || !showDefaultNav ? (
                  <img src={pin2} alt="Kontakt" />
                ) : (
                  <img src={pin} alt="Kontakt" />
                )}
                <span>Kontakt</span>
              </PageLink>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
